<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="550px"
  >
    <v-card :loading="loading">
      <v-card-title>
        <span v-if="item.id">Cập nhật item#{{item.id}}</span>
        <span v-else>Thêm mới</span>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div v-if="errors_exist" class="row">
            <div class="col">
              <v-alert
                dense
                outlined
                type="error"
              >
                {{ $vuetify.lang.t('$vuetify.msg.hasError') }}
                <ul>
                  <div v-for="(error, index) in errors">
                    <li :key="index">{{ error[0] }}</li>
                  </div>
                </ul>
              </v-alert>
            </div>
          </div>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="item.thoi_gian"
                label="Thời gian"
                class="require"
                v-mask="'##/##/#### - ##:##'"
                autofocus
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.ho_ten"
                label="Người gọi"
                class="require"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
            >
              <v-text-field
                v-model="item.so_dien_thoai"
                label="Số điện thoại"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
            >
              <v-text-field
                v-model="item.email"
                label="Email"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
            >
              <v-select
                v-model="capDoSelected"
                :items="cap_dos"
                item-text="name"
                item-value="id"
                label="Cấp độ"
                return-object
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
            >
              <v-select
                v-model="branchSelected"
                :items="branchs"
                item-text="name"
                item-value="id"
                label="Lĩnh vực"
                return-object
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="kenhSelected"
                :items="kenhs"
                item-text="name"
                item-value="id"
                label="Kênh liên hệ"
                return-object
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="item.noi_dung"
                label="Nội dung"
                rows="3"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small><span class="pink--text">(*)</span> bắt buộc nhập</small>
        <v-spacer/>
        <v-btn
          color="pink darken-1"
          text
          @click="close"
        >
          Hủy bỏ
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="save(item)"
        >
          Lưu lại
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        cap_dos: [
          {id: 1, name: 'Cấp 1 - Những thắc mắc liên quan đến quy trình xử lý hồ sơ, thủ tục hành chính'},
          {id: 2, name: 'Cấp 2 - Những nội dung phát sinh trên các lĩnh vực'},
          {id: 3, name: 'Cấp 3 - Chậm thực hiện hoặc thực hiện không hiệu quả'},
          {id: 4, name: 'Cấp 4 - Cần trao đổi trực tiếp'}
        ],
        capDoSelected: null,
        branchs: [],
        branchSelected: null,
        kenhs: [
          {id: 'phone', name: 'Điện thoại'},
          {id: 'sms', name: 'SMS'},
          {id: 'email', name: 'Email'}
        ],
        kenhSelected: null,
      }
    },
    mounted() {
      this.dialog = this.showDialog;
      this.getBranchs();
    },
    watch: {
      showDialog() {
        this.dialog = false;
        this.errors_exist=false;
        if (this.showDialog) {
          this.dialog = true;
          if(this.item.cap_do_id) {
            this.capDoSelected = this.cap_dos.find(
              element => element.id == this.item.cap_do_id
            );
          }
          if(this.item.linh_vuc_id){
            this.branchSelected = this.branchs.find(
              element => element.id == this.item.linh_vuc_id
            );
          }
          if(this.item.kenh){
            this.kenhSelected = this.kenhs.find(
              element => element.id == this.item.kenh
            );
          }
        }
      }
    },
    methods: {
      getBranchs () {
        axios.get("api/v1/branchs")
          .then(response => {
            this.branchs = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      save(item) {
        const app = this;
        let method = "post";
        let url = `api/v1/callcenters`;
        let data = item; 

        if(app.capDoSelected){
          data.cap_do_id = app.capDoSelected.id;
        }

        if(app.branchSelected){
          data.linh_vuc_id = app.branchSelected.id;
        }

        if(app.kenhSelected){
          data.kenh = app.kenhSelected.id;
        }

        if (data.id) {
          method = "patch";
          url = `api/v1/callcenters/${data.id}`;
        }

        app.loading=true;
        
        axios[method](url, data)
          .then((response) => {
            if (response.data && response.data.id) {
              app.$emit('confirmed', response.data);
            } 
            app.loading=false;
          }).catch(function (error) {
            app.loading=false;
            app.errors_exist = true;
            if(error.response.status === 422) {
              app.errors = error.response.data || {};
            }
          });
      }
    }
  }
</script>